/** @jsx jsx */
import { jsx, Flex } from 'theme-ui';
import React, { FunctionComponent } from 'react';
import classNames from 'classnames';

// Components
import FluidImage from '@codersclan/gatsby-theme-airfleet/src/components/fluidImage';

// Styles
import { baseStyle } from './style';

// Hooks
import useAvatarOverlay from '../../hooks/useAvatarOverlay';

export interface AvatarProps {
  className?: string;
  size?: (string | null)[];
  image: ImageType;
}

const Avatar: FunctionComponent<AvatarProps> = React.memo(
  ({ className, size = '280px', image }) => {
    const overlay = useAvatarOverlay();
    const equalSizeImage = { ...image };
    if (equalSizeImage?.localFile?.childImageSharp?.fluid) {
      equalSizeImage.localFile.childImageSharp.fluid.aspectRatio = 1;
    }
    return (
      <Flex
        className={classNames('Avatar', className)}
        sx={{
          ...baseStyle.mainContainer,
          width: size,
          minWidth: size,
          height: size,
        }}
      >
        <FluidImage {...equalSizeImage} sx={baseStyle.image} />
        {overlay && overlay.fluid && (
          <FluidImage
            title=""
            localFile={overlay.fluid}
            altText="overlay"
            sourceUrl={overlay.fluid}
            sx={baseStyle.overlayImage}
          />
        )}
      </Flex>
    );
  },
);

export default Avatar;
